"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var stepNumberKeys = ['formStepOne', 'formStepTwo', 'formStepThree', 'formStepFour', 'formStepFive', 'formStepSix', 'formStepSeven', 'formStepEight'];

var getStepNumberKey = function getStepNumberKey(stepNumber) {
  if (!stepNumber) return;
  var keyIndex = stepNumber - 1;
  var key = stepNumberKeys[keyIndex];
  if (key) return _defineProperty({}, key, 1);
};

var _default = {
  stepNumberKeys: stepNumberKeys,
  getStepNumberKey: getStepNumberKey
};
exports["default"] = _default;